import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import { OptionType } from "../../../../helpers/utils/StyleUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import SelectField from "../../../../components/common/form/SelectField";
import { createOptionListForSelectTag, getObjectiveArray } from "../../../../helpers/utils/Utils";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { Routes as AppRoutes } from "../../../../routes";
import { useGetAllStatesQuery } from "../../../data/states/statesApi";
import {
    useSearchManagementCompanyApiQuery
} from "../../managementCompany/managementCompany";
import { useGetAllCountyByStateAbbrQuery } from "../../../data/counties/countiesApi";
import { skipToken } from "@reduxjs/toolkit/query";
import ModalButton from "../../../../components/common/form/ModalButton";
import { FaMagnifyingGlass } from "react-icons/fa6";
import AddEditContactForm from "../../../../components/common/form/AddEditContactForm";
import { FaLink, FaPlus, FaSearch, FaTimes } from "react-icons/fa";
import CommonSelectorModal from "../../../../components/common/form/CommonSelectorModal";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import {
    useSearchThirdPartyProviderApiQuery
} from "../../thirdPartyProvider/thirdPartyProvider";
import { useCreateAssociationDetailApiMutation } from "../associationApi";
import IconButton from "../../../../components/common/form/IconButton";
import CommonChosenInputContact from "../../../../components/common/form/CommonChosenInputContact";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";


const CreateAssociation: FC = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/" },
        { content: "Associations", url: AppRoutes.Association.path },
        { content: "Add Associations", url: "" },
    ]);

    const navigate = useNavigate();
    const [associationData, setAssociationData] = useState<any>({ state: { label: "Texas", value: "TX" } });;
    const { data: enums } = useGetEnumsQuery("");
    const [createApi, createApiResponse] = useCreateAssociationDetailApiMutation();
    const statesApiResult = useGetAllStatesQuery("");
    const countiesApiResult = useGetAllCountyByStateAbbrQuery(associationData?.state?.value ?? skipToken);
    const [disableCompany, setDisableCompany] = useState(false);
    const [disableProvider, setDisableProvider] = useState(false);
    const [contactData, setContactData] = useState({});
    const [showProviderModal, setShowProviderModal] = useState<boolean>(false);
    const [showManagementCompanyModal, setShowManagementCompanyModal] = useState<boolean>(false);
    const iconButtonStyle = "fa cursor-pointer text-highlight-0 absolute left-auto right-5 top-6";
    const [names, setNames] = useState<any>([]);
    const [index, setIndex] = useState<any>(null);
    const [showUpdateContactForm, setShowUpdateContactForm] = useState(false);
    const [showAddContactModal, setShowAddContactModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>({});

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const filteredContacts = (associationData?.contacts || []).filter((contact: any) =>
            names.includes(contact.name)
        );

        const obj: any = {
            name: associationData?.name,
            county: {
                id: associationData?.county?.value
            },
            contacts: filteredContacts,
            status: associationData?.status?.value,
            ...((disableCompany && {
                hoaThirdPartyProvider: {
                    id: selectedRow?.id
                }
            })),
            ...((disableProvider && {
                managementCompany: {
                    id: selectedRow?.id
                }
            }))
        };
        await handleRTKQuery(
            async () => {
                return await createApi(obj).unwrap();
            },
            (response: any) => {
                setAssociationData({});
                navigate(AppRoutes.Association.path);
            }
        );
    }
    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const { name, value } = "target" in e ? e.target : e;
        if (name === "state") {
            setAssociationData({
                ...associationData,
                county: null,
                [name]: value,

            })
        }
        setAssociationData({
            ...associationData,
            [name]: value,
        })
    }
    const handleOnClick = (e: any, name: string) => {
        e.preventDefault();
        if (name === "hoaThirdPartyProvider") {
            setAssociationData({
                ...associationData,
                [name]: selectedRow
            })
            setShowProviderModal(false)
            setDisableCompany(true)
        } else {
            setAssociationData({
                ...associationData,
                [name]: selectedRow
            })
            setDisableProvider(true)
            setShowManagementCompanyModal(false)
        }
    }

    useEffect(() => {
        if (index != null && associationData?.contacts?.[index]) {
            setContactData({
                ...associationData.contacts[index],
                preferredContactMethod: associationData.contacts[index]?.preferredContactMethod
                    ? {
                        value: associationData.contacts[index]?.preferredContactMethod,
                        label: getEnumDisplayNameByConstant(
                            enums?.["ContactMethod"],
                            associationData.contacts[index]?.preferredContactMethod
                        ),
                    }
                    : null,
                address: {
                    ...associationData.contacts[index]?.address,
                    state: associationData.contacts[index]?.address?.state
                        ? {
                            value: associationData.contacts[index]?.address?.state,
                            label: statesApiResult?.data?.find(
                                (el: any) => el.id === associationData.contacts[index]?.address?.state
                            )?.stateName,
                        }
                        : null,
                },
            });
        }
    }, [index, associationData, enums, statesApiResult?.data]);


    useEffect(() => {
        let val = associationData?.customerLevel?.value;
        if (val === "TENANT") {
            setAssociationData({
                ...associationData,
                tenantId: null
            })
        }

    }, [associationData?.customerLevel]);

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "name",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''} />
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "name"
            }],
        }
    ]

    const onclickAddContacts = (data: any) => {
        setNames((prevNames: string[]) => [...prevNames, data.name]);

        const cleanedContact = {
            ...data,
            preferredContactMethod: data?.preferredContactMethod?.value,
            address: {
                ...data?.address,
                state: data?.address?.state?.value || null
            }
        };

        setAssociationData((prevData: any) => ({
            ...prevData,
            contacts: [...(prevData.contacts || []), cleanedContact],
        }));

        setContactData({});
    };

    const updateContact = (objToUpdate: any) => {
        const updatedContact = {
            ...objToUpdate,
            preferredContactMethod: objToUpdate?.preferredContactMethod?.value,
            address: {
                ...objToUpdate?.address,
                state: objToUpdate?.address?.state?.value || null
            }
        };

        setAssociationData((prevData: any) => {
            const updatedContacts = [...(prevData.contacts || [])];
            updatedContacts[index] = updatedContact;

            return {
                ...prevData,
                contacts: updatedContacts,
            };
        });

        const copyNames = [...names];
        copyNames[index] = objToUpdate.name;
        setNames(copyNames);

        setContactData({});
        setIndex(null);
    };


    const handleClearField = (fieldName: string) => {
        setAssociationData((prevData: any) => {
            const updatedData = {
                ...prevData,
                [fieldName]: '',
            };
            const isThirdPartyProviderSet = !!updatedData.hoaThirdPartyProvider;
            const isManagementCompanySet = !!updatedData.managementCompany;

            setDisableProvider(isManagementCompanySet);
            setDisableCompany(isThirdPartyProviderSet);

            return updatedData;
        });
    };

    return (
        <>

            <div className="adduser_container px-4 py-2">

                <Breadcrumb crumbs={crumbs} />
                <div className="flex justify-center mt-3">
                    <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                        <h3 className="text-xl font-semibold text-surface-0 pb-3 border-b border-surface-7">Add
                            Association
                        </h3>

                        <Form onSubmit={handleSubmit} fields={<>

                            <div className="grid grid-cols-12 adduser_Wrapper">
                                <InputField
                                    name={"name"}
                                    label="Name"
                                    onChange={handleOnChange}
                                    value={associationData?.name || ""}
                                    type="text"
                                    placeholder="Enter Name..."
                                    required={true}
                                />

                                <SelectField
                                    placeholder='Select State...'
                                    value={associationData?.state}
                                    options={createOptionListForSelectTag(statesApiResult?.data, "stateName", "stateAbbreviation")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({ name: "state", value: selectedOption })
                                    }}
                                    label={"State"}
                                    required={true}
                                />
                                <SelectField
                                    placeholder='Select County...'
                                    value={associationData?.county}
                                    options={createOptionListForSelectTag(countiesApiResult?.data, "countyName", "id")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({ name: "county", value: selectedOption })
                                    }}
                                    label={"County"}
                                    required={true}
                                    isDisabled={!associationData?.state}
                                />


                                <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
                                    <div className="col-span-3 sm:mt-2 lg-mt-0 mt-2 flex items-center">
                                        <div className="text-surface-0 flex items-center">Contacts</div>
                                    </div>
                                    <div className="col-span-9 mt-3">

                                        <div className="border border-text-1 p-2 relative rounded-[3px]">
                                            <CommonChosenInputContact placeholder={"Enter Contacts..."}
                                                state={getObjectiveArray(names)}
                                                setState={setNames}
                                                isRequired={false}
                                                setShowUpdateContactForm={setShowUpdateContactForm}
                                                setIndex={setIndex}
                                                isReadOnly
                                            />

                                            <div className="absolute right-[5px] top-[13px] flex items-center">
                                                {associationData?.contacts?.length > 0 && names.length > 0 &&
                                                    <IconButton
                                                        icon={<FaTimes />}
                                                        onClick={() => {

                                                            setAssociationData((prevData: any) => ({
                                                                ...prevData,
                                                                contacts: [],
                                                            }));
                                                            setNames([]);
                                                        }}
                                                    />
                                                }
                                                <IconButton
                                                    icon={<FaPlus />}
                                                    onClick={() => {
                                                        setShowAddContactModal(true)
                                                        setAssociationData((prevData: any) => ({
                                                            ...prevData,
                                                            contacts: [],
                                                        }));
                                                        setNames([]);
                                                    }}
                                                />
                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <SelectField
                                    placeholder='Select Status...'
                                    value={associationData?.status || null}
                                    options={createOptionListForSelectTag(enums?.["AssociationStatus"], "value", "constant")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({ name: "status", value: selectedOption })
                                    }}
                                    label={"Status"}
                                />

                                <InputField
                                    name="managementCompany"
                                    label="Management Company"
                                    onChange={handleOnChange}
                                    value={associationData?.managementCompany?.name || ""}
                                    type="text"
                                    disabled={disableCompany}
                                    placeholder="Enter Management Company..."
                                    onClick={() => {
                                        setShowManagementCompanyModal(true);
                                    }}
                                    className="cursor-pointer"
                                    icon={<IconButton
                                        icon={<FaLink onClick={() => {
                                            if (selectedRow?.id && !disableCompany) {
                                                window.open(`/management-companies/${selectedRow.id}`, '_blank');
                                            }
                                        }} />
                                        }
                                        className={`text-sm ${associationData?.managementCompany ? 'text-highlight-4' : 'text-surface-4'
                                            }`}
                                        title={"Create Management Company"}
                                    />}
                                    inputIcon={
                                        !disableCompany && (
                                            disableProvider ? (
                                                <FaTimes
                                                    className={iconButtonStyle}
                                                    title="Clear Management Company"
                                                    onClick={() => handleClearField("managementCompany")}
                                                />
                                            ) : (
                                                <FaSearch
                                                    className={iconButtonStyle}
                                                    title="Add Management Company"
                                                    onClick={() => setShowManagementCompanyModal(true)}
                                                />
                                            )
                                        )
                                    }
                                />
                                <InputField
                                    name="hoaThirdPartyProvider"
                                    label="Third Party Provider"
                                    onChange={handleOnChange}
                                    value={associationData?.hoaThirdPartyProvider?.name || ""}
                                    type="text"
                                    disabled={disableProvider}
                                    placeholder="Enter Third Party Provider..."
                                    icon={<IconButton
                                        icon={<FaLink onClick={() => {
                                            if (selectedRow?.id && !disableProvider) {
                                                window.open(`/third-party-providers/${selectedRow.id}`, '_blank');
                                            }
                                        }} />
                                        }
                                        className={`text-sm ${associationData?.hoaThirdPartyProvider ? 'text-highlight-4' : 'text-surface-4'
                                            }`}
                                        title={"Create Third Party Provider"}
                                    />}
                                    onClick={() => {
                                        setShowProviderModal(true);
                                    }}
                                    className="cursor-pointer"
                                    inputIcon={
                                        !disableProvider && (
                                            disableCompany ? (
                                                <FaTimes
                                                    className={iconButtonStyle}
                                                    title="Clear Third Party Provider"
                                                    onClick={() => handleClearField("hoaThirdPartyProvider")}
                                                />
                                            ) : (
                                                <FaSearch
                                                    className={iconButtonStyle}
                                                    title="Add Provider Detail"
                                                    onClick={() => {
                                                        setShowProviderModal(true);
                                                    }}
                                                />
                                            ))
                                    }
                                />

                            </div>

                            <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
                                <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                </div>
                                <div className="relative col-span-9">
                                    <div className={"mt-4 flex"}>
                                        <ButtonTray
                                            buttons={[
                                                {
                                                    buttonProps: {
                                                        btnText: "Cancel",
                                                        onClick: () => navigate(AppRoutes.Association.path),
                                                        type: "cancel",
                                                    },
                                                    buttonType: "button"
                                                },
                                                {
                                                    buttonProps: {
                                                        btnText: "Submit",
                                                        type: "submit",
                                                        isLoading: (createApiResponse.isLoading),
                                                    },
                                                    buttonType: "button"
                                                }
                                            ]}
                                            align="end"
                                            gap={2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>} />
                    </div>
                </div>
                {showProviderModal &&
                    <CommonSelectorModal
                        title="Third Party Selector"
                        columns={columns}
                        data={useSearchThirdPartyProviderApiQuery}
                        show={showProviderModal}
                        onSubmit={(e: any) => handleOnClick(e, "hoaThirdPartyProvider")}
                        setShow={setShowProviderModal}
                        setSelectedRow={setSelectedRow}
                    />
                }
                {showManagementCompanyModal &&
                    <CommonSelectorModal
                        title="Management Company Selector"
                        columns={columns}
                        data={useSearchManagementCompanyApiQuery}
                        show={showManagementCompanyModal}
                        onSubmit={(e: any) => handleOnClick(e, "managementCompany")}
                        setShow={setShowManagementCompanyModal}
                        setSelectedRow={setSelectedRow}
                    />
                }

                {
                    showUpdateContactForm && <AddEditContactForm
                        formType={"Update"}
                        show={showUpdateContactForm}
                        setShow={setShowUpdateContactForm}
                        onSubmit={(contactData: any) => updateContact(contactData)}
                        setContactData={setContactData}
                        contactData={contactData}
                        overrideDismissMethod={() => {
                            setIndex(null);
                            setContactData({});
                        }}
                    />
                }

                {
                    showAddContactModal && <AddEditContactForm
                        formType={"Add"}
                        show={showAddContactModal}
                        setShow={setShowAddContactModal}
                        onSubmit={(contactData: any) => onclickAddContacts(contactData)}
                        setContactData={setContactData}
                        contactData={contactData}
                        overrideDismissMethod={() => {
                            setContactData({})
                        }}
                    />
                }
            </div>

        </>
    )
}

export default CreateAssociation;